import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API = `${apiMainUrl}bank-config`;

const authHdr = token => ({ headers: { Authorization: `Bearer ${token}` } });

/* helper – generates CRUD funcs for any path ------------------------ */
const crud = (path) => ({
  create: async (dto, token) => (await axios.post(`${API}/${path}`, dto, authHdr(token))).data,
  getAll: async (token)       => (await axios.get (`${API}/${path}`,       authHdr(token))).data,
  getById: async (id, token)  => (await axios.get (`${API}/${path}/${id}`, authHdr(token))).data,
  update: async (id, dto, token) => await axios.put(`${API}/${path}/${id}`, dto, authHdr(token)),
  remove: async (id, token)   => await axios.delete(`${API}/${path}/${id}`, authHdr(token))
});

/* exported service object ------------------------------------------ */
export const BankConfigDataService = {
  companies:     crud('companies'),
  bankAuths:     crud('bank-auths'),
  bankServices:  crud('bank-services'),
  accounts:      crud('accounts')
};
